import React from "react";
import { ContactUsText2 } from "./__ContactUs";
import NavbarSave from "../components/navbar-save";
import Footer from "../components/footer";

const title = "Terms and Conditions";

const TermsConditions = () => {
  return (
    <>
      <NavbarSave />
      <div className="bg-white w-100 h-100 overflow-y-auto" style={{ paddingTop: 156 }}>
        <div className="container">
          <div className="fs-1 fw-bold">{title}</div>
          <p className="mb-5">Last updated: {new Date().getFullYear()}</p>
          <div className="text-left">
            <TermsConditionsText />
          </div>
          <div className="py-5" />
          <div className="py-5" />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsConditions;

function TermsConditionsText() {
  return (
    <>
      <div className="fs-3 fw-semibold mt-5">1. Introduction</div>
      <p className="fs-5">
        Welcome to <strong>SAVE (Secure AI-Based Vulnerability Assessment Tool for Enterprises)</strong>, 
        a proprietary cybersecurity platform developed, owned, and maintained solely by 
        <strong> CYBERSECOPS PRIVATE LIMITED</strong>. By accessing or using our website, 
        platform, or any related services, you agree to be bound by the terms and conditions outlined below. 
        These Terms govern your relationship with CYBERSECOPS PRIVATE LIMITED (“we,” “our,” “us”) 
        and your use of SAVE, including all features, updates, and content provided through the platform. 
        Please read these Terms carefully before proceeding, as they constitute a legally binding agreement 
        between you and CYBERSECOPS PRIVATE LIMITED.
      </p>

      <div className="fs-3 fw-semibold mt-5">2. Ownership and Intellectual Property</div>
      <p className="fs-5">
        All software, algorithms, code, features, designs, interfaces, trademarks, trade names, and other 
        proprietary elements of SAVE are and shall remain the exclusive intellectual property of 
        CYBERSECOPS PRIVATE LIMITED. The platform has been designed and developed entirely in-house by our 
        cybersecurity engineers and software developers, without any involvement of third-party vendors. 
        Unauthorized copying, modification, reverse engineering, resale, or redistribution of any part of SAVE 
        is strictly prohibited and may result in legal action under applicable intellectual property laws.
      </p>

      <div className="fs-3 fw-semibold mt-5">3. Use of Services</div>
      <p className="fs-5">
        By using SAVE, you agree to use the platform solely for lawful cybersecurity evaluation and analysis 
        purposes. You must not use the service in any way that violates applicable laws, regulations, or 
        industry standards. You also agree not to attempt to interfere with, hack, or gain unauthorized access 
        to any part of the platform, its servers, or associated systems. Any activity that compromises data 
        integrity, disrupts service functionality, or endangers system security may lead to immediate termination 
        of access and potential legal consequences.
      </p>

      <div className="fs-3 fw-semibold mt-5">4. Account Registration and Security</div>
      <p className="fs-5">
        To access certain features of SAVE, you may be required to create an account. You agree to provide 
        accurate, complete, and up-to-date information during registration. You are solely responsible for 
        maintaining the confidentiality of your login credentials and for all activities conducted under your 
        account. CYBERSECOPS PRIVATE LIMITED shall not be liable for any loss or damage resulting from your 
        failure to maintain the security of your account credentials. If you suspect unauthorized access, 
        you must notify us immediately.
      </p>

      <div className="fs-3 fw-semibold mt-5">5. Subscription, Billing, and Payment</div>
      <p className="fs-5">
        SAVE operates under a subscription-based model, offering both monthly and yearly plans. 
        By subscribing, you authorize CYBERSECOPS PRIVATE LIMITED or its authorized payment gateway to charge 
        the applicable fees using your chosen payment method. All payments are processed securely through 
        approved payment partners. Fees are non-refundable unless otherwise stated under our Refund Policy. 
        You are responsible for maintaining accurate billing information to avoid disruptions in service. 
        Access to SAVE may be suspended or terminated if payments are not successfully processed.
      </p>

      <div className="fs-3 fw-semibold mt-5">6. Data Privacy and Security</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED takes user data privacy and cybersecurity seriously. 
        All personal, organizational, and system data collected through SAVE are handled in compliance with 
        applicable data protection laws. We do not sell, lease, or share user information with external parties. 
        All data processing and analysis are performed securely within our controlled infrastructure. 
        For detailed information about how we collect, use, and protect your data, please refer to our 
        <a href="/privacy-policy" className="text-decoration-none"> Privacy Policy</a>.
      </p>

      <div className="fs-3 fw-semibold mt-5">7. License and Access Rights</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED grants you a limited, non-exclusive, non-transferable, and revocable license 
        to access and use SAVE solely for internal business purposes or educational use (as applicable). 
        This license does not grant ownership of any part of the platform. Any breach of these Terms, 
        including unauthorized access, data extraction, or modification of system components, 
        will result in immediate termination of the license.
      </p>

      <div className="fs-3 fw-semibold mt-5">8. Limitation of Liability</div>
      <p className="fs-5">
        To the maximum extent permitted by law, CYBERSECOPS PRIVATE LIMITED shall not be liable for any direct, 
        indirect, incidental, consequential, or special damages arising from the use or inability to use SAVE, 
        including but not limited to loss of data, loss of profits, business interruption, or unauthorized 
        system access. The platform is provided “as is” and “as available” without warranties of any kind, 
        whether express or implied.
      </p>

      <div className="fs-3 fw-semibold mt-5">9. Termination of Service</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED reserves the right to suspend, restrict, or terminate your account or access 
        to SAVE at any time, with or without prior notice, if we believe that you have violated these Terms or 
        engaged in activities detrimental to the integrity of our systems or other users. Termination does not 
        relieve you of your obligation to pay outstanding fees or comply with ongoing confidentiality requirements.
      </p>

      <div className="fs-3 fw-semibold mt-5">10. Changes to Terms</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED may modify these Terms and Conditions periodically to reflect operational, 
        legal, or regulatory changes. The updated Terms will be published on this page with a revised “Last Updated” date. 
        Continued use of SAVE following such changes constitutes your acceptance of the updated Terms.
      </p>

      <div className="fs-3 fw-semibold mt-5">11. Governing Law and Jurisdiction</div>
      <p className="fs-5">
        These Terms shall be governed by and construed in accordance with the laws of India. 
        Any disputes or claims arising out of or relating to SAVE or these Terms shall fall under 
        the exclusive jurisdiction of the courts located in Kolkata, West Bengal.
      </p>

      <div className="fs-3 fw-semibold mt-5">12. Contact Information</div>
      <p className="fs-5">
        For questions, clarifications, or concerns regarding these Terms and Conditions, please reach out to:
      </p>
      <ContactUsText2 />
    </>
  );
}
